export default __webpack_public_path__ + "static/media/mypacomefavicon.330dc2bb.svg";